"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Strings = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var Strings = /** @class */function () {
  function Strings() {}
  Strings.errors = {
    unknownElementType: function (typeName) {
      return "Unknown element type \"".concat(typeName, "\". Fallback will be used if present.");
    },
    unknownActionType: function (typeName) {
      return "Unknown action type \"".concat(typeName, "\". Fallback will be used if present.");
    },
    elementTypeNotAllowed: function (typeName) {
      return "Element type \"".concat(typeName, "\" is not allowed in this context.");
    },
    actionTypeNotAllowed: function (typeName) {
      return "Action type \"".concat(typeName, "\" is not allowed in this context.");
    },
    invalidPropertyValue: function (value, propertyName) {
      return "Invalid value \"".concat(value, "\" for property \"").concat(propertyName, "\".");
    },
    showCardMustHaveCard: function () {
      return "\"An Action.ShowCard must have its \"card\" property set to a valid AdaptiveCard object.";
    },
    invalidColumnWidth: function (invalidWidth) {
      return "Invalid column width \"".concat(invalidWidth, "\" - defaulting to \"auto\".");
    },
    invalidCardVersion: function (defaultingToVersion) {
      return "Invalid card version. Defaulting to \"".concat(defaultingToVersion, "\".");
    },
    invalidVersionString: function (versionString) {
      return "Invalid version string \"".concat(versionString, "\".");
    },
    propertyValueNotSupported: function (value, propertyName, supportedInVersion, versionUsed) {
      return "Value \"".concat(value, "\" for property \"").concat(propertyName, "\" is supported in version ").concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
    },
    propertyNotSupported: function (propertyName, supportedInVersion, versionUsed) {
      return "Property \"".concat(propertyName, "\" is supported in version ").concat(supportedInVersion, ", but you are using version ").concat(versionUsed, ".");
    },
    indexOutOfRange: function (index) {
      return "Index out of range (".concat(index, ").");
    },
    elementCannotBeUsedAsInline: function () {
      return "RichTextBlock.addInline: the specified card element cannot be used as a RichTextBlock inline.";
    },
    inlineAlreadyParented: function () {
      return "RichTextBlock.addInline: the specified inline already belongs to another RichTextBlock.";
    },
    interactivityNotAllowed: function () {
      return "Interactivity is not allowed.";
    },
    inputsMustHaveUniqueId: function () {
      return "All inputs must have a unique Id.";
    },
    choiceSetMustHaveAtLeastOneChoice: function () {
      return "An Input.ChoiceSet must have at least one choice defined.";
    },
    choiceSetChoicesMustHaveTitleAndValue: function () {
      return "All choices in an Input.ChoiceSet must have their title and value properties set.";
    },
    propertyMustBeSet: function (propertyName) {
      return "Property \"".concat(propertyName, "\" must be set.");
    },
    actionHttpHeadersMustHaveNameAndValue: function () {
      return "All headers of an Action.Http must have their name and value properties set.";
    },
    tooManyActions: function (maximumActions) {
      return "Maximum number of actions exceeded (".concat(maximumActions, ").");
    },
    tooLittleTimeDelay: function (minAutoplayDelay) {
      return "Autoplay Delay is too short (".concat(minAutoplayDelay, ").");
    },
    tooManyCarouselPages: function (maxCarouselPages) {
      return "Maximum number of Carousel pages exceeded (".concat(maxCarouselPages, ").");
    },
    invalidInitialPageIndex: function (initialPageIndex) {
      return "InitialPage for carousel is invalid (".concat(initialPageIndex, ").");
    },
    columnAlreadyBelongsToAnotherSet: function () {
      return "This column already belongs to another ColumnSet.";
    },
    invalidCardType: function () {
      return "Invalid or missing card type. Make sure the card's type property is set to \"AdaptiveCard\".";
    },
    unsupportedCardVersion: function (version, maxSupportedVersion) {
      return "The specified card version (".concat(version, ") is not supported or still in preview. The latest released card version is ").concat(maxSupportedVersion, ".");
    },
    duplicateId: function (id) {
      return "Duplicate Id \"".concat(id, "\".");
    },
    markdownProcessingNotEnabled: function () {
      return "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown";
    },
    processMarkdownEventRemoved: function () {
      return "The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.";
    },
    elementAlreadyParented: function () {
      return "The element already belongs to another container.";
    },
    actionAlreadyParented: function () {
      return "The action already belongs to another element.";
    },
    elementTypeNotStandalone: function (typeName) {
      return "Elements of type ".concat(typeName, " cannot be used as standalone elements.");
    },
    invalidInputLabelWidth: function () {
      return "Invalid input label width. Defaulting to label width from host config.";
    }
  };
  Strings.magicCodeInputCard = {
    tryAgain: function () {
      return "That didn't work... let's try again.";
    },
    pleaseLogin: function () {
      return 'Please login in the popup. You will obtain a magic code. Paste that code below and select "Submit"';
    },
    enterMagicCode: function () {
      return "Enter magic code";
    },
    pleaseEnterMagicCodeYouReceived: function () {
      return "Please enter the magic code you received.";
    },
    submit: function () {
      return "Submit";
    },
    cancel: function () {
      return "Cancel";
    },
    somethingWentWrong: function () {
      return "Something went wrong. This action can't be handled.";
    },
    authenticationFailed: function () {
      return "Authentication failed.";
    }
  };
  Strings.runtime = {
    automaticRefreshPaused: function () {
      return "Automatic refresh paused.";
    },
    clckToRestartAutomaticRefresh: function () {
      return "Click to restart.";
    },
    refreshThisCard: function () {
      return "Refresh this card";
    }
  };
  Strings.hints = {
    dontUseWeightedAndStrecthedColumnsInSameSet: function () {
      return "It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.";
    }
  };
  Strings.defaults = {
    inlineActionTitle: function () {
      return "Inline Action";
    },
    overflowButtonText: function () {
      return "...";
    },
    overflowButtonTooltip: function () {
      return "More options";
    },
    emptyElementText: function (elementType) {
      return "Empty ".concat(elementType);
    },
    mediaPlayerAriaLabel: function () {
      return "Media content";
    },
    mediaPlayerPlayMedia: function () {
      return "Play media";
    },
    youTubeVideoPlayer: function () {
      return "YouTube video player";
    },
    vimeoVideoPlayer: function () {
      return "Vimeo video player";
    },
    dailymotionVideoPlayer: function () {
      return "Dailymotion video player";
    },
    carouselNavigationPreviousTooltip: function () {
      return "Previous carousel page";
    },
    carouselNavigationNextTooltip: function () {
      return "Next carousel page";
    }
  };
  return Strings;
}();
exports.Strings = Strings;